import React from "react";
import MeasurementBar from "./MeasurementBar";
import clsx from "clsx";
import { Box, Typography } from '@curves/ui-base';

const MeasurementBarItem = ({ className, name, value = 0, unit, minValue = 0, maxValue = 99, normalRange = [], percentageProp }) => {
	const isDisplayBar = normalRange.length > 0;

	return (
		<Box className={clsx("measurement-bar-item", isDisplayBar ? "measurement-bar-item--with-bar" : "measurement-bar-item--no-bar", className)}>
			<Box className="measurement-bar-item__wrap">
				<Typography variant="h5" className="measurement-bar-item__title">
					{name}
				</Typography>
				<Box className="measurement-bar-item__bar">
					<MeasurementBar value={value} normalRange={normalRange} minValue={minValue} maxValue={maxValue} percentageProp={percentageProp} showLabels={false} showTicks={false} />
				</Box>
				<Box className="measurement-bar-item__value measurement-bar-item__value--normal">
					{value}
					{/* {unit && <span className="measurement-bar-item__value-unit">{unit}</span>} */}
				</Box>
			</Box>
		</Box>
	);
};

export default MeasurementBarItem;
